<template>
  <h1 v-if="date" class="proof-date-separator" :data-proofs-date="date">
    <div class="sticky-date-content">
      {{ date | prettyDate }}
      <v-divider />
    </div>
  </h1>
</template>

<script>
import Vue from 'vue'

export default Vue.extend({
  name: 'DateSeparator',

  props: {
    date: {
      type: Date,
      required: true,
    },
  },
})
</script>

<style lang="scss">
.proof-date-separator {
  position: sticky;
  top: 0;
  z-index: 1;

  .sticky-date-content {
    background: $white;
    box-shadow: 0 0 18px rgba(255, 255, 255, 1);
    line-height: 60px;
  }
}
</style>
